// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"650":"b91b02fe","685":"17632530","912":"a77f92a1"}[chunkId] + ".chunk.js";
};